import { queryAdmin } from '../graphql-client';

export const GET_COLLAB_USERS = /* GraphQL */ `
  query getProjectMembersLocationList($projectId: String!) {
    members: getProjectMembersLocationList(projectId: $projectId) {
      userId
      contentList {
        contentId
        shapeId
        hasLock
      }
    }
  }
`;

export const getCollabUsersQuery = queryAdmin(GET_COLLAB_USERS);
